import { render, staticRenderFns } from "./InvoicePayoffTransaction.vue?vue&type=template&id=552711c4&scoped=true"
import script from "./InvoicePayoffTransaction.vue?vue&type=script&lang=js"
export * from "./InvoicePayoffTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552711c4",
  null
  
)

export default component.exports